// extracted by mini-css-extract-plugin
module.exports = {"createGroupButtonContainer":"ThirdPartyAccessManagement-tab_createGroupButtonContainer_d3PM3"};